// import React from "react";
// import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// import ProductListing from "./containers/ProductListing";
// import Header from "./containers/Header";
// import "./App.css";
// import ProductDetails from "./containers/ProductDetails";

// function App() {
//   return (
//     <div className="App">
//       <Router>
//         <Header />
//         <Switch>
//           <Route path="/" exact component={ProductListing} />
//           <Route path="/product/:productId" component={ProductDetails} />
//           <Route>404 Not Found!</Route>
//         </Switch>
//       </Router>
//     </div>
//   );
// }

// export default App;

import React from 'react';
import Header from './containers/Header';
import ProductListing from './containers/ProductListing';
import './App.css'

import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";

import ProductDetails from './containers/ProductDetails';

const App = () => {
  return (
    <div>
       
      <BrowserRouter>
      <Header/>
   
      <Routes>
      <Route path="/" element={<ProductListing />}/>
      <Route path="/product/:productId" element={<ProductDetails/>}/>
      <Route>  404 Not Found!...</Route>

      </Routes>
     
      </BrowserRouter>
   
     
      
    </div>
  );
};

export default App;
